export default __webpack_public_path__ + "static/media/Flag_of_Philippines.74598bcb.svg";